import React from 'react';

const BOLD_REGEX = /(<b>.*?<\/b>)/g;
/**
 * Parse a message with tags into TSX with those tags.
 * Currently supports <b> tags.
 * @param content - Raw message string
 * @returns - The parsed message with <b> tags inserted
 */

export const parseMessageWithFormat = (text: string | null | undefined): React.ReactNode[] | React.ReactNode => {
  if (!text) {
    return <></>;
  }
  // Split into <b>...</b> chunks
  const parts = text.split(BOLD_REGEX);

  return parts.map((part, i) => {
    if (part.startsWith('<b>') && part.endsWith('</b>')) {
      // Strip the literal tags and replace them with JSX
      return <b key={i}>{part.slice(3, -4)}</b>;
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
};

/**
 * Parse a message with \n markers into a ul element with the message split into
 * li elements.
 * @param content - Raw message string
 * @returns - ul element
 */
export const parseMessageToList = (content: string) => {
  if (!content) return <></>;

  return (
    <ul>
      {content.split('\n').map((item, i) => (
        <li key={i}>{parseMessageWithFormat(item)}</li>
      ))}
    </ul>
  );
};
